// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

// Make bootstrap available globally for Stimulus controllers
window.bootstrap = bootstrap

function initBootstrapWidgets(root = document) {
  root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    if (!bootstrap.Tooltip.getInstance(el)) new bootstrap.Tooltip(el)
  })
  root.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
    if (!bootstrap.Popover.getInstance(el)) new bootstrap.Popover(el)
  })
}

// Full page loads
document.addEventListener("turbo:load", () => initBootstrapWidgets(document))

// Turbo Frame loads (e.g. the trackers table polling refresh) — scope to
// the newly-loaded frame so we don't re-init widgets elsewhere on the page.
document.addEventListener("turbo:frame-load", (event) => {
  initBootstrapWidgets(event.target)
})
